module.exports = __webpack_public_path__ + "static/media/logoclinica.a2d429aa.png";